module.exports = __webpack_public_path__ + "sunsemweb/img/55.c08e453e.png";